export default __webpack_public_path__ + "static/header.klepschgroup-628ab0284c64e2282018f1fa793d65ad.jpg";